<template>
  <div>
    <ShowIfWrapper :input="input" :block="block">
      <v-text-field
        v-if="input.type === 'text'"
        :value="parent[input.property]"
        outlined
        dense
        :placeholder="input.label"
        autocomplete="off"
        @input="onInputChange($event)"
        class="dynamic-input"
        :disabled="block.hasOwnProperty('disableInputs')"
      ></v-text-field>
    </ShowIfWrapper>
    <v-text-field
      v-if="input.type === 'number'"
      type="number"
      v-model="parent[input.property]"
      outlined
      dense
      :placeholder="input.label"
      autocomplete="off"
      @input="onInputChange($event)"
      class="dynamic-input"
      :disabled="block.hasOwnProperty('disableInputs')"
    ></v-text-field>
    <v-textarea
      v-else-if="input.type === 'textarea'"
      v-model="parent[input.property]"
      outlined
      dense
      :placeholder="input.label"
      autocomplete="off"
      type="textarea"
      @input="onInputChange($event)"
      class="dynamic-input"
      v-hover
      :disabled="block.hasOwnProperty('disableInputs')"
    ></v-textarea>
    <TextAreaWithHTML
      v-else-if="input.type === 'textareawithhtml'"
      :content="parent[input.property]"
      @input="onInputChange($event)"
      :label="input.label"
      class="dynamic-input"
      v-hover
      :disabled="block.hasOwnProperty('disableInputs')"
    ></TextAreaWithHTML>
    <v-switch
      v-else-if="input.type === 'switch'"
      v-model="parent[input.property]"
      :label="input.label"
      @change="onInputChange($event ? true : false)"
      dense
      class="dynamic-input"
      flat
      inset
      :disabled="block.hasOwnProperty('disableInputs')"
    ></v-switch>
    <v-select
      v-else-if="input.type === 'select'"
      :label="input.label"
      :items="input.values"
      dense
      outlined
      :value="parent[input.property]"
      @change="onInputChange($event)"
      class="dynamic-input"
      :disabled="block.hasOwnProperty('disableInputs')"
    ></v-select>
    <ImagePicker
      v-else-if="input.type === 'image'"
      :url="parent[input.property]"
      @input="onInputChange($event)"
      :modes="['LIBRARY', 'UPLOAD']"
      defaultMode="LIBRARY"
      :tooltip="input.label"
      :disabled="block.hasOwnProperty('disableInputs')"
    ></ImagePicker>
    <IconPicker
      v-else-if="input.type === 'icon'"
      :icon="parent[input.property]"
      @input="onInputChange($event)"
      :disabled="block.hasOwnProperty('disableInputs')"
    ></IconPicker>
    <NotificationConfig
      v-else-if="input.type === 'notification-config'"
      :block="block"
    ></NotificationConfig>
    <LinkBuilder
      v-else-if="input.type === 'links'"
      :links="parent[input.property]"
      :block="block"
      :label="input.label"
      @input="onInputChange($event)"
      :fullpath="[...pathprefix, input.property]"
      :disabled="block.hasOwnProperty('disableInputs')"
    ></LinkBuilder>
    <v-alert
      v-else-if="input.type === 'alert'"
      :type="input.variant"
      v-html="input.label"
      text
      border="left"
      :disabled="block.hasOwnProperty('disableInputs')"
    ></v-alert>
    <ColorPickerInput
      v-else-if="input.type === 'color'"
      :label="input.label"
      :color="parent[input.property]"
      @input="onInputChange($event)"
      :disabled="block.hasOwnProperty('disableInputs')"
    ></ColorPickerInput>
    <slot />
  </div>
</template>

<script>
import projectMixin from "../project-mixin";
import ImagePicker from "../../ImagePicker";
import IconPicker from "../../IconPicker";
import LinkBuilder from "./LinkBuilder";
import NotificationConfig from "./NotificationConfig";
import ColorPickerInput from "../../ColorPickerInput";
import TextAreaWithHTML from "../../TextAreaWithHTML";
import ShowIfWrapper from "./ShowIfWrapper";

export default {
  props: ["block", "input", "parent", "pathprefix"],
  components: {
    ImagePicker,
    IconPicker,
    LinkBuilder,
    NotificationConfig,
    ColorPickerInput,
    TextAreaWithHTML,
    ShowIfWrapper,
  },
  mixins: [projectMixin],
  methods: {
    onInputChange($event) {
      this.$emit("l-change", $event);
    },
  },
};
</script>